import type { ReactNode } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface SiteLayoutProps {
  children: ReactNode;
  topOffset?: boolean;
}

export default function SiteLayout({ children, topOffset = false }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 w-full ${topOffset ? "pt-16 md:pt-[68px]" : ""}`}>{children}</main>
      <Footer />
    </div>
  );
}